<template>
  <button 
    type="button" 
    class="btn-plain"
    :class="[
      interview ? 'btn-heart-fill' : 'btn-heart',
      fromSearchBar ? 'custom-size' : ''
    ]"
    :disabled="toggledisabledInt"
  >
    <svg
      width="40"
      height="40"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class="interview-svg"
      :class="{ 'interview-active': interview }"
    >
      <g id="レイヤー_2" data-name="レイヤー 2">
        <g id="Rectangle">
          <rect width="48" height="48"/>
        </g>
        <g id="icon_data">
          <path d="M16,10H8a2,2,0,0,0-2,2V40a2,2,0,0,0,2,2H40a2,2,0,0,0,2-2V12a2,2,0,0,0-2-2H38"/>
          <line x1="16" y1="6" x2="16" y2="14"/>
          <line x1="32" y1="6" x2="32" y2="14"/>
          <line x1="22" y1="10" x2="32" y2="10"/>
          <polyline points="17.5 27 22.5 32 30.5 24"/>
        </g>
      </g>
    </svg>
  </button>
</template>

<script>
export default {
  name: 'Interview',
  props: ['interview', 'toggledisabledInt','fromSearchBar']
};
</script>
<style scoped>
.interview-svg {
  transition: all 0.2s ease;
}

.interview-svg path,
.interview-svg line,
.interview-svg polyline {
  fill: none;
  stroke: #000;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2px;
}

.interview-active {
  transform: scale(1.1);
}

.interview-active path,
.interview-active line,
.interview-active polyline {
  stroke: #ff0000 !important;
}

.custom-size .interview-svg {
  width: 30px;
  height: 30px;
}

.prof-head-left .btn-heart:hover .interview-svg path,
.prof-head-left .btn-heart:hover .interview-svg line,
.prof-head-left .btn-heart:hover .interview-svg polyline,
.one-right .btn-heart:hover .interview-svg path,
.one-right .btn-heart:hover .interview-svg line,
.one-right .btn-heart:hover .interview-svg polyline {
    stroke: #aba2a2;
}

.prof-head-left .btn-heart-fill:hover .interview-svg path,
.prof-head-left .btn-heart-fill:hover .interview-svg line,
.prof-head-left .btn-heart-fill:hover .interview-svg polyline,
.one-right .btn-heart-fill:hover .interview-svg path,
.one-right .btn-heart-fill:hover .interview-svg line,
.one-right .btn-heart-fill:hover .interview-svg polyline {
    stroke: #bf3404;
}
</style>

